import * as React from 'react';

export type ProgressLineProps = {
	reach: string | number;
	total: string | number;
	text: string;
	percent: number | string;
};

const ProgressLine = ({ reach, total, text, percent }: ProgressLineProps) => (
	<div className="m-progress-line">
		<div className="m-progress-line__info">
			<div className="m-progress-line__info-title">
				<span className="m-progress-line__info-title-reach">{reach}</span>
				<span className="m-progress-line__info-title-slash">/</span>
				<span className="m-progress-line__info-title-total">{total}</span>
			</div>
			<div className="m-progress-line__info-text">{text}</div>
		</div>
		<div className="m-progrss-line__wrap">
			<div className="m-progress-line__meter">
				<div className="m-progress-line__value" style={{ width: `${percent}%` }} />
			</div>
		</div>
	</div>
);

export default ProgressLine;
